export default function (editor) {
	editor.on("init", function () {
		const images = editor.dom.select("img");

		images.forEach((img) => {
			if (img.classList.contains("img-50")) {
				img.style.width = "50%";
				img.setAttribute("data-mce-style", "50%");
			}
			if (img.classList.contains("img-75")) {
				img.style.width = "75%";
				img.setAttribute("data-mce-style", "75%");
			}
			if (img.classList.contains("img-100")) {
				img.style.width = "100%";
				img.setAttribute("data-mce-style", "100%");
			}
		});
	});

	editor.on("input", function (e) {
		window.isFormChanged = true;
	});

	editor.on("NodeChange", function (e) {
		console.log("node change", e);
		if (e && e.element.nodeName.toLowerCase() == "img") {
			console.log(e.element, "change");

			const img = e.element;

			if (img.classList.contains("img-50")) {
				e.element.style.width = "50%";
				img.setAttribute("data-mce-style", "50%");
			} else if (img.classList.contains("img-75")) {
				e.element.style.width = "75%";
				img.setAttribute("data-mce-style", "75%");
			} else if (img.classList.contains("img-100")) {
				e.element.style.width = "100%";
				img.setAttribute("data-mce-style", "100%");
			}
		}
	});
}
